/* eslint-disable
	@typescript-eslint/explicit-module-boundary-types,
	@typescript-eslint/no-explicit-any,
	@typescript-eslint/no-unsafe-assignment,
	@typescript-eslint/no-unused-vars,
	@typescript-eslint/no-unsafe-member-access
*/
import I18Next from "../../Control/Vue/I18Next";
import { prompt } from "./../../Control/Vue/Notifications/Prompts";
import { HandlerType } from "./HandlerType";
import { postUrlEncoded } from "../LegacyAxiosUtil";

/**
 * This is a base class of the classes that are attached to controls,
 * that require a singular request, and informative dialogs on errors
 */
export abstract class RequestHandler implements HandlerType {
	protected loading = false;

	private errorRequestDoneMessage: Promise<string>;
	private errorRequestFailMessage: Promise<string>;

	constructor(protected readonly element: JQuery) {
		const customErrorRequestDoneMessage = element.data("error-request-done");
		const customErrorRequestFailMessage = element.data("error-request-fail");

		this.errorRequestDoneMessage = customErrorRequestDoneMessage
			? Promise.resolve(customErrorRequestDoneMessage)
			: I18Next.tr("error_request_data_not_saved");

		this.errorRequestFailMessage = customErrorRequestFailMessage
			? Promise.resolve(customErrorRequestFailMessage)
			: I18Next.tr("error_request_failed");
	}

	protected async sendRequest(url: string, data: Record<string, any>): Promise<void> {
		if (this.loading) {
			return;
		}

		this.loading = true;
		let response: any;
		try {
			response = await postUrlEncoded(url, data, { skipDefaultErrorHandler: true });
		}
		catch {
			this.onFail(null);
		}
		finally {
			this.loading = false;
		}

		this.onDone(response.data);
	}

	/*
	 * This determines what happens post-request,
	 * when the request returns with success in its body
	 */
	protected abstract onSuccess(_: any): void;

	protected onError(_: any): void {
		void this.errorRequestDoneMessage.then((message) => prompt(message,
			[{ label: I18Next.tr("OkCancel_Ok"), value: undefined }]));
	}

	protected onDone(res: any): void {
		if (res.success) {
			this.onSuccess(res);
		}
		else {
			this.onError(res);
		}
	}

	protected onFail(_: any): void {
		void this.errorRequestFailMessage.then((message) => prompt(message,
			[{ label: I18Next.tr("OkCancel_Ok"), value: undefined }]));
	}
}
